/**
 * Freedom to Speak Up — gated by `freedomToSpeakUpEnabled` on company config (same as `expertsEnabled`).
 * Enable per company in the DB; company-config API must return `freedomToSpeakUpEnabled: true`.
 */

/** Employee-facing UI and routes — company config only (mirrors experts). */
export const isFreedomToSpeakUpFeatureEnabled = (freedomToSpeakUpEnabled?: boolean): boolean =>
  Boolean(freedomToSpeakUpEnabled);

/**
 * Employer admin scaffold only: skip permission 404 while building UI without full admin API.
 * Does not affect employee routes.
 */
export const FREEDOM_TO_SPEAK_UP_DEFAULT_ON_FOR_DEV = false;
